document.querySelectorAll(".faq-item--heading").forEach( function( el ) {
    el.addEventListener("click", function() { 
        if ( el.classList.contains("active") ) {
            el.classList.remove("active");
            el.nextElementSibling.style.maxHeight = "0px";
        } else {
            document.querySelectorAll(".accordion__title").forEach( function( acc ) {
                acc.classList.remove("active");
                acc.nextElementSibling.style.maxHeight = `0px`;
            } );
            el.classList.add("active");
            el.nextElementSibling.style.maxHeight = `${el.nextElementSibling.scrollHeight}px`;
        }
    } )
} );